export default __webpack_public_path__ + "static/media/soudeur_small.c527fb03.webp";